module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Gb-Ha-Ia-Ga.385051f9.png";